import React, { Component } from 'react'
import HttpClient from '../../helpers/httpClient';
import AppCard from '../container/card';
import Loader from './../loader/loader';

import { Trans, withTranslation } from "react-i18next";

class MyApps extends Component {
    constructor(props) {
        super(props);
        this.loader = React.createRef();
    }

    state = {
        myAppsCollection: [],
        loading: true,
        errorMessage: null
    }

    async componentDidMount() {
        this.loader.current.show(true);
        const serviceResponse = await HttpClient.send(`${process.env.REACT_APP_AUTHORIZATION_API_URL}/users/${this.props.userName}/services`);
        const jsonResult = await serviceResponse.json();
        let errorMessage = null;
        let myAppsCollection = [];

        if (serviceResponse.ok) {
            myAppsCollection = jsonResult.results;
        } else {
            if(jsonResult.errorCode === 'SEC.UNAUTH.002') {
                window.location.replace(process.env.REACT_APP_REDIRECT_PASSWORD_RESET_URL);
            } else {
                errorMessage = jsonResult.errorMessage;
            }
        }

        this.setState({ 'loading': false, 'myAppsCollection': myAppsCollection, 'errorMessage': errorMessage });
        this.loader.current.show(false);
    }

    render() {
        return (
            <div className="container pb-5 mb-5">
                <Loader ref={this.loader} />
                <div className="row row-cols-1 row-cols-md-4">
                    {this.state.myAppsCollection !== null && this.state.myAppsCollection.map((item, index) => {
                        return <div className="col mt-3" key={index}><AppCard key={index} app={item} /></div>
                    })
                    }
                </div>
                {
                    !this.state.loading && this.state.myAppsCollection.length === 0 &&
                    <div className='row'>
                        <div className="alert alert-danger d-flex align-items-center" role="alert">
                            <svg xmlns="https://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" className="bi bi-window-x" viewBox="0 0 16 16">
                                <path d="M2.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM4 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z" />
                                <path d="M0 4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v4a.5.5 0 0 1-1 0V7H1v5a1 1 0 0 0 1 1h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-2V4Zm1 2h13V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2Z" />
                                <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-4.854-1.354a.5.5 0 0 0 0 .708l.647.646-.647.646a.5.5 0 0 0 .708.708l.646-.647.646.647a.5.5 0 0 0 .708-.708l-.647-.646.647-.646a.5.5 0 0 0-.708-.708l-.646.647-.646-.647a.5.5 0 0 0-.708 0Z" />
                            </svg>
                            <div>
                                <Trans>{this.state.errorMessage ?? 'global.apps.noresults'}</Trans>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default withTranslation('translation')(MyApps);
